import {
  ComponentRef,
  Directive,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import { ExtendableButton, setInputs } from '../../button.types';
import { SpinnerComponent } from './../../../spinner/spinner.component';

@Directive({
  selector:
    'rt-button-new[loading], a[rt-button-new][loading], rt-icon-button[loading], a[rt-icon-button][loading]',
})
export class ButtonLoadingDirective implements OnChanges, OnDestroy {
  @Input() public loading: boolean = false;

  private spinnerComponentRef: ComponentRef<SpinnerComponent> | null = null;

  constructor(@Inject(ExtendableButton) private button: ExtendableButton) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.loading) {
      this.toggleSpinner();
    }
  }

  public ngOnDestroy() {
    if (this.spinnerComponentRef) {
      this.spinnerComponentRef.destroy();
    }
  }

  public toggleSpinner() {
    if (this.loading) {
      this.spinnerComponentRef = this.button.secondarySlot.createComponent(SpinnerComponent);
      setInputs(this.spinnerComponentRef, { variant: 'small' });
      this.button.addClass('loading');
    } else if (this.spinnerComponentRef) {
      this.spinnerComponentRef.destroy();
      this.spinnerComponentRef = null;
      this.button.removeClass('loading');
    }
  }
}
